import { inject, Injectable } from '@angular/core';

import type { IPersonalDataProtectionPolicy } from 'src/services/personal-data-protection/interfaces/personal-data-protection-policy.interface';
import type { IConsentState, TConsentType } from 'src/services/personal-data-protection/types';
import { Source } from 'src/services/personal-data-protection/types';

import { FALLBACK_CONSENT_STATE } from './entities/const';
import { UserCentricsService } from './user-centrics.service';

@Injectable()
export class UserCentricsPolicy implements IPersonalDataProtectionPolicy {
    private readonly userCentricsService = inject(UserCentricsService);

    saveConsent(result: IConsentState): void {
        return;
    }

    public getGlobalConsentState(): Promise<IConsentState> {
        return this.userCentricsService.isUserCentricsLoadedAsync().then((isLoaded) => {
            return isLoaded ? this.userCentricsService.getConsentState() : FALLBACK_CONSENT_STATE;
        });
    }

    public isConsentRequired(consentType: TConsentType, source: Source): Promise<boolean> | boolean {
        switch (source) {
            case Source.Decorator:
            case Source.Stub:
                return this.getGlobalConsentState().then((state) => !state[consentType]);
            case Source.Page:
                return false;
        }

        return false;
    }
}
